import { render, staticRenderFns } from "./CreateHrDocumentModal.vue?vue&type=template&id=2eb16168&scoped=true&"
import script from "./CreateHrDocumentModal.vue?vue&type=script&lang=js&"
export * from "./CreateHrDocumentModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateHrDocumentModal.vue?vue&type=style&index=0&id=2eb16168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb16168",
  null
  
)

export default component.exports